export default __webpack_public_path__ + "static/media/image_limited.98654931.png";